
export const techTerms = [
  // 🔹 Programming & Frameworks
  "Python",
  "TensorFlow",
  "PyTorch",
  "JAX",
  "Scikit-learn",
  "NumPy",
  "Pandas",
  "Matplotlib",
  "Seaborn",
  "Plotly",
  "Streamlit",
  "Gradio",
  "Jupyter Notebook",
  "Google Colab",
  "Anaconda",
  "Conda",
  "Pip Install",
  "Virtual Environment",
  "Visual Studio Code",
  "Vim",
  "Sublime Text",
  "React",
  "Next.js",
  "Node.js",
  "Express.js",
  "FastAPI",
  "Flask",
  "Django",
  "HTML",
  "CSS",
  "JavaScript",
  "TypeScript",
  "Bootstrap",
  "Tailwind CSS",
  "MongoDB",
  "MySQL",
  "PostgreSQL",
  "SQLite",
  "JWT",
  "Supabase",
  "Firebase",
  "EZSync",
  "Git",
  "GitHub",
  "GitLab",
  "Bitbucket",
  "Dockerfile",
  "Docker Compose",
  "YAML",
  "Bash Script",
  "Command Line Interface",
  "Terminal",
  "Shell Script",
  "PowerShell",

  // 🔹 Machine Learning Algorithms
  "LSTM",
  "GRU",
  "CNN",
  "RNN",
  "Transformer",
  "Random Forest",
  "Decision Tree",
  "Naive Bayes",
  "KNN",
  "SVM",
  "XGBoost",
  "CatBoost",
  "LightGBM",
  "PCA",
  "t-SNE",
  "UMAP",
  "MLP",
  "Backpropagation",
  "Gradient Boosting",
  "Logistic Regression",
  "Linear Regression",
  "Polynomial Regression",
  "K Means",
  "DBSCAN",
  "Hierarchical Clustering",
  "Isolation Forest",
  "Ensemble Learning",
  "Cross Validation",
  "Grid Search",
  "Random Search",
  "Hyperparameter Tuning",
  "ROC Curve",
  "Confusion Matrix",
  "Precision",
  "Recall",
  "F1 Score",
  "AUC Score",
  "Mean Squared Error",
  "Mean Absolute Error",
  "Root Mean Squared Error",

  // 🔹 Deep Learning & AI Concepts
  "Generative AI",
  "Fine-tuning",
  "Prompt Engineering",
  "Retrieval-Augmented Generation",
  "RAG",
  "Tokenization",
  "Embeddings",
  "Latent Space",
  "Diffusion Model",
  "Autoregressive Model",
  "Reinforcement Learning",
  "RLHF",
  "SFT",
  "DPO",
  "LoRA",
  "Q LoRA",
  "Adapter Tuning",
  "Parameter Efficient Tuning",
  "Attention Mechanism",
  "Self-Attention",
  "Multi-Head Attention",
  "Transformer Block",
  "Context Window",
  "Gradient Descent",
  "Vanishing Gradient",
  "Exploding Gradient",
  "Overfitting",
  "Underfitting",
  "Batch Size",
  "Epoch",
  "Learning Rate",
  "Normalization",
  "Regularization",
  "Dropout",
  "Convolution",
  "Activation Function",
  "Softmax",
  "Sigmoid",
  "ReLU",
  "Tanh",
  "Adam Optimizer",
  "SGD",
  "Loss Function",
  "Cost Function",
  "Weight Initialization",
  "Early Stopping",
  "Model Evaluation",
  "Model Drift",
  "Concept Drift",
  "Model Deployment",
  "Quantization",
  "Pruning",
  "Knowledge Distillation",

  // 🔹 NLP & Text Processing
  "Token",
  "Vector",
  "Text Corpus",
  "Lemmatization",
  "Stemming",
  "Bag of Words",
  "TF-IDF",
  "Stopwords",
  "Word2Vec",
  "GloVe",
  "BERT",
  "DistilBERT",
  "RoBERTa",
  "ALBERT",
  "T5",
  "XLNet",
  "ELECTRA",
  "Sentence Transformer",
  "Named Entity Recognition",
  "POS Tagging",
  "Text Classification",
  "Sentiment Analysis",
  "Summarization",
  "Translation",
  "Question Answering",
  "Text Generation",
  "Speech Recognition",
  "Audio Transcription",
  "Speech Synthesis",
  "Voice Assistant",
  "Multimodal Model",
  "Vision Transformer",
  "ViT",
  "CLIP",
  "Whisper",
  "AudioLM",
  "Speech Embeddings",

  // 🔹 GenAI Models & Tools
  "GPT",
  "ChatGPT",
  "GPT-4",
  "GPT-4o",
  "GPT-5",
  "OpenAI",
  "Hugging Face",
  "LangChain",
  "LangGraph",
  "Llama",
  "Llama 3",
  "Claude",
  "Claude 3 Opus",
  "Anthropic",
  "Ollama",
  "Mistral",
  "Gemini",
  "DeepSeek",
  "Perplexity",
  "Cohere",
  "Stability AI",
  "Stable Diffusion",
  "Midjourney",
  "Runway ML",
  "Replicate",
  "ComfyUI",
  "ControlNet",
  "Flux",
  "Sora",
  "Pika Labs",
  "Video Diffusion",
  "RunDiffusion",
  "Image Generation",
  "Text to Speech",
  "Speech to Text",
  "Voice Cloning",
  "AI Agent",
  "Agentic Workflow",
  "Memory Chain",
  "Function Calling",
  "Prompt Template",
  "JSON Mode",
  "Streaming Response",
  "Tool Calling",
  "Assistants API",
  "Custom GPTs",
  "Fine-tuned Model",
  "RAG Pipeline",
  "Prompt Chaining",
  "Context Retrieval",
  "Chat Memory",
  "Multi-Agent System",
  "AutoGPT",
  "BabyAGI",
  "CrewAI",
  "SuperAGI",
  "Devin AI",
  "Vercel AI SDK",
  "LangSmith",
  "LangServe",

  // 🔹 Cloud, DevOps & Infra
  "Azure",
  "AWS",
  "GCP",
  "IBM Cloud",
  "Oracle Cloud",
  "Digital Ocean",
  "Render",
  "Kubernetes",
  "Docker",
  "Containerization",
  "API",
  "Endpoint",
  "API Key",
  "Serverless",
  "Lambda Function",
  "Virtual Machine",
  "Compute Instance",
  "Elastic Beanstalk",
  "Cloud Run",
  "S3 Bucket",
  "IAM Role",
  "Load Balancer",
  "Webhook",
  "CI CD Pipeline",
  "Terraform",
  "Helm Chart",
  "CloudFormation",
  "VPC",
  "Auto Scaling",
  "KubeCTL",
  "Ingress Controller",
  "Pod",
  "Deployment",
  "Service Mesh",
  "Istio",
  "ArgoCD",
  "Prometheus",
  "Grafana",
  "OpenTelemetry",
  "Ray Serve",
  "Ray Cluster",
  "KServe",
  "Triton Inference Server",

  // 🔹 Vector Databases & GenAI Infra
  "Vector Database",
  "Pinecone",
  "Chroma",
  "Weaviate",
  "Milvus",
  "FAISS",
  "Qdrant",
  "Elastic Vector Search",
  "LanceDB",
  "Redis Vector",
  "Mongo Vector Search",
  "Token Limit",
  "Embedding Model",
  "Indexing",
  "Chunking",
  "Document Splitting",
  "Context Retrieval",
  "Query Expansion",
  "Retriever",
  "Memory Store",
  "Hybrid Search",
  "Similarity Score",
  "Knowledge Graph",
  "Semantic Search",
  "Reranking",
  "BM25",

  // 🔹 Data Engineering & Analytics
  "Data Pipeline",
  "Data Cleaning",
  "Feature Engineering",
  "ETL",
  "ELT",
  "Data Warehouse",
  "Snowflake",
  "BigQuery",
  "Power BI",
  "Tableau",
  "Data Lake",
  "Delta Lake",
  "Parquet File",
  "CSV",
  "JSON",
  "YAML File",
  "Azure Synapse",
  "DataBricks",
  "Apache Spark",
  "Hadoop",
  "Airflow",
  "Kafka",
  "NiFi",
  "Flume",
  "Stream Processing",
  "Batch Processing",
  "Data Governance",
  "Data Catalog",
  "Data Lineage",
  "OLAP Cube",
  "Feature Store",
  "Data Quality Monitoring",

  // 🔹 AI Ethics & Responsible AI
  "Bias Detection",
  "Model Explainability",
  "Interpretability",
  "Fairness",
  "Transparency",
  "Privacy Preservation",
  "Differential Privacy",
  "Federated Learning",
  "Data Security",
  "AI Safety",
  "Alignment",
  "Red Teaming",
  "Content Filtering",
  "Watermarking",
  "Synthetic Data",
  "Adversarial Attack",
  "Model Robustness",
  "Responsible AI Policy",
  "Ethical AI Governance",
  "Audit Trail",

  // 🔹 Robotics & Edge AI
  "ROS",
  "Edge TPU",
  "Jetson Nano",
  "Raspberry Pi",
  "OpenCV AI Kit",
  "Arduino",
  "Furhat",
  "Ohbot",
  "Picoh",
  "Reinforcement Learning for Robotics",
  "SLAM",
  "Path Planning",
  "Object Tracking",
  "Gesture Recognition",
  "Speech Interaction",
  "Voice Command",
  "Humanoid Robot",
  "AI Companion",
  "Emotion Recognition",

  // 🔹 Benchmarks & Datasets
  "ImageNet",
  "COCO Dataset",
  "MNIST",
  "CIFAR-10",
  "SQuAD",
  "GLUE Benchmark",
  "SuperGLUE",
  "HumanEval",
  "MMLU",
  "TruthfulQA",
  "ARC Benchmark",
  "VQA",
  "Common Crawl",
  "Pile Dataset",
  "LAION Dataset",

  // 🔹 Academic & Research Terms
  "Backpropagation Through Time",
  "Gradient Clipping",
  "Soft Prompting",
  "Zero Shot Learning",
  "Few Shot Learning",
  "Transfer Learning",
  "Meta Learning",
  "Contrastive Learning",
  "Self Supervised Learning",
  "Unsupervised Learning",
  "Supervised Learning",
  "Semi Supervised Learning",
  "Reinforcement Learning",
  "Curriculum Learning",
  "Knowledge Graph Embedding",
  "Latent Variable Model",
  "Bayesian Network",
  "Markov Decision Process",
  "Monte Carlo Tree Search",

  // 🔹 Audio, Vision & Video AI
  "Lip Syncing",
  "3D Reconstruction",
  "Depth Estimation",
  "Optical Flow",
  "Video Captioning",
  "Audio Segmentation",
  "Voice Separation",
  "Music Generation",
  "Sound Classification",
  "Speech Enhancement",
  "TTS Pipeline",
  "ASR Model",
  "Face Swapping",
  "Avatar Generation",
  "AI Video Editor"
];